'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.whichSellerCatalogCountsNeeded = exports.shouldFetchSellerCatalogCounts = exports.getSellerCatalogCounts = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _seller = require('../modules/seller');

var _cloneDeep = require('lodash/cloneDeep');

var _cloneDeep2 = _interopRequireDefault(_cloneDeep);

var _reselect = require('reselect');

var _difference = require('lodash/difference');

var _difference2 = _interopRequireDefault(_difference);

var _ms = require('ms');

var _ms2 = _interopRequireDefault(_ms);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* Action Types */

var REDUX_STORE_TIME = (0, _ms2.default)('30m');

/* reducer */
var DEFAULT_STATE = {
    byId: {},
    loaded: {},
    loading: []
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_STATE;
    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var existing = void 0;
    var loaded = void 0;
    var loading = void 0;
    var time = void 0;

    switch (action.type) {
        case _seller.LOAD_SELLERS_FAIL:
            return (0, _extends3.default)({}, state, {
                loading: (0, _difference2.default)(state.loading, action.meta.sellerIds)
            });
        case _seller.LOAD_SELLERS_REQUEST:
            return (0, _extends3.default)({}, state, {
                loading: (0, _union2.default)(state.loading, action.payload)
            });
        case _seller.LOAD_SELLERS_SUCCESS:
            existing = (0, _cloneDeep2.default)(state.byId);
            loaded = (0, _extends3.default)({}, state.loaded);
            loading = (0, _cloneDeep2.default)(state.loading);
            time = action.meta.actionTime;

            if (action.payload.sellerCatalogCounts) {
                action.payload.sellerCatalogCounts.forEach(function (item) {
                    existing[item.sellerId] = (0, _extends3.default)({}, item, {
                        upcomingCount: item.liveCount + item.onlineCount
                    });
                    loaded[item.sellerId] = time;
                    loading = (0, _difference2.default)(loading, [item.sellerId]);
                });
            }
            return (0, _extends3.default)({}, state, {
                byId: existing,
                loaded: loaded,
                loading: loading
            });
        default:
            return state;
    }
}

/* SELECTORS */
var stateSelector = function stateSelector(state) {
    return state.domain.sellerCatalogCounts;
};
var idSelector = function idSelector(state, id) {
    return id;
};

var byIdSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.byId;
});

var loadedSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loaded;
});

var loadingSelector = (0, _reselect.createSelector)(stateSelector, function (state) {
    return state.loading;
});

// takes in a (state, id) and returns data
var getSellerCatalogCounts = exports.getSellerCatalogCounts = (0, _reselect.createSelector)([byIdSelector, idSelector], function (byId, id) {
    return byId[id] || { doneCount: 0, liveCount: 0, onlineCount: 0, upcomingCount: 0 };
});

// takes in a (state, id) and returns load time
var getLoadTimeForSellerCatalogCounts = (0, _reselect.createSelector)([loadedSelector, idSelector], function (loaded, id) {
    return loaded[id] || 0;
});

// takes in a (state, id) and returns if data is loading
var isSellerCatalogCountsLoading = (0, _reselect.createSelector)([loadingSelector, idSelector], function (loading, id) {
    return loading.indexOf(id) !== -1;
});

var shouldFetchSellerCatalogCounts = exports.shouldFetchSellerCatalogCounts = function shouldFetchSellerCatalogCounts(state, sellerId) {
    if (!sellerId) return false;
    var item = getSellerCatalogCounts(state, sellerId);
    if (item) {
        var loaded = getLoadTimeForSellerCatalogCounts(state, sellerId);
        var time = Date.now();
        var diff = time - loaded;
        if (diff < REDUX_STORE_TIME) return false;
    }
    var loading = isSellerCatalogCountsLoading(state, sellerId);
    return !loading;
};

var whichSellerCatalogCountsNeeded = exports.whichSellerCatalogCountsNeeded = function whichSellerCatalogCountsNeeded(state, sellerIds) {
    return sellerIds.filter(function (sellerId) {
        return shouldFetchSellerCatalogCounts(state, sellerId);
    });
};


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/sellerCatalogCounts.js
// module id = 9vxb
// module chunks = 57